/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：816
 */

module.exports = {
  dialog: "PermissionDialog_dialog__1zySM",
  permissionImage: "PermissionDialog_permissionImage__2BieN",
  content: "PermissionDialog_content__1bDd2",
  dialogButtons: "PermissionDialog_dialogButtons__3x0tN",
  dialogSecondary: "PermissionDialog_dialogSecondary__LsUkX",
  denyButton: "PermissionDialog_denyButton__3kF3I"
}
